/** 2FA modal strings (extracted to keep en.ts under the size ratchet). */
export const enTwoFA = {
	code: "Code",
	cta: "Confirm",
	title: "Enter 2FA Code",
};
